import { gql } from '@apollo/client';
import { CONVERSATION_FIELDS_FRAGMENT } from 'api/tickets/queries/conversationFieldsFragment.gql';

export const EXPERT_QUEUE_FIELDS_FRAGMENT = gql`
  ${CONVERSATION_FIELDS_FRAGMENT}
  fragment ExpertQueueFields on ExpertQueue {
    objectId: id
    createdAt
    updatedAt
    Comments
    isActive
    nominatedAt
    assignedAt
    messageArrivedAt
    nominationExpiresAt
    simplrExpertId
    conversationId
    messageId
    conversationPtr {
      ...ConversationFields
    }
  }
`;
